import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import Container from "@mui/material/Container"
import CustomImage from "../../components/custom-image/custom-image.component"
import { Typography } from "@mui/material"
import BackgroundPattern from "../../components/background-pattern/background-pattern.component"

export const Section = styled(SectionWrapper)`
  padding-bottom: 5rem;
  padding-top: 0;
  background-color: #e8ecfb;
  border-radius: 0px 0px 24px 24px;
`

export const Wrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-top: 6.25rem;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: 8.5rem;
  }
`

export const ImageWrapper = styled(BackgroundPattern)`
  width: 100%;
  ::before {
    z-index: 2;
    background-size: 289px auto;
    opacity: 0.04;
  }
`

export const CustomBgImage = styled(CustomImage)`
  width: 100%;
  height: 100%;

  > .gatsby-image-wrapper {
    height: 100%;
    max-height: 22.8125rem;
    img {
      border-radius: 0.75rem;
    }
  }

  ${({ theme }) => theme.breakpoints.up("sm")} {
    > .gatsby-image-wrapper {
      height: 100%;
      img {
        border-radius: 1rem;
        /* filter: grayscale(100%); */
      }
    }
  }
`
export const TextWrapper = styled.div`
  display: flex;
  //position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 2.5rem;
`

export const DateAuthorWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  padding-bottom: 0.75rem;
`
export const Date = styled(Typography)`
  font-family: ${({ theme }) => theme.fonts.primary};
  text-align: center;
  font-size: 0.9375rem;
  line-height: normal;
  letter-spacing: 0.04688rem;
`
export const Square = styled(Typography)`
  font-size: 0.9375rem;
  line-height: 2.5;
  font-size: 0.5rem;
`
export const Author = styled(Typography)`
  text-align: center;
  font-size: 0.9375rem;
  line-height: normal;
  letter-spacing: 0.04688rem;
`
export const Title = styled(Typography)`
  font-family: ${({ theme }) => theme.fonts.secondary};
  text-align: center;
  font-size: 2rem;
  line-height: 2.75rem;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    line-height: 3.25rem;
    font-size: 2.5rem;
  }
`

export const SocialMediaIconsWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding-top: 1.75rem;
  flex-wrap: wrap;
`

export const SocialMediaIcon = styled.a`
  cursor: pointer;
  position: relative;
  border: 1px solid black;
  border-radius: 100%;
  padding: 0.77rem;
  line-height: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
`
